<div class="crowdfunding__wrapper" *ngIf="CrowdfundingView === CVTypes.Helper"
  ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'pt-6 pr-3' : 'pt-4'}}">

  <div class="crowdfunding__content">
    <div class="crowdfunding__heading">
      <h5>Помогите проекту стать лучше</h5>
    </div>
    <div class="crowdfunding__subtitle">
      <div class="no-padding"
        ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'col-8' : 'col-12'}}">

        <p>Каждый рубль помогает проекту стать лучше, нам важна любая помощь и поддержка.</p>
      </div>
    </div>
    <div class="crowdfunding__text">
      <div class="col-8 no-padding">
        <p>
          Всех, кто помогают, создатели сообщества лично благодарят и добавляют в особый список (или чат),
          в котором в будущем будут появляться уникальные предложения, доступные только тем, кто был с нами с самого начала.
        </p>
      </div>
    </div>
    <div class="crowdfunding__picture">
      <div class="ui-graphics__balalaika-dark"></div>
    </div>
  </div>
</div>


<div class="crowdfunding__wrapper" *ngIf="CrowdfundingView === CVTypes.Donate"
  ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'pt-6 pl-3' : 'pt-4'}}">

  <div class="crowdfunding__content">
    <div class="crowdfunding__heading">
      <h5>Поддержать проект напрямую</h5>
    </div>
    <div class="crowdfunding__text">
      <div class="crowdfunding__counter">
        <div class="grid align-items-center pt-4">
          <div class="col-6 no-padding">
            <div class="crowdfunding__counter-donate_current">
              <p>{{onParseNumberValue(CrowdCountCurrent)}}</p>
              <span>руб.</span>
            </div>
          </div>
          <div class="col-6 no-padding">
            <div class="crowdfunding__counter-donate_info">
              <p>Обновление данных происходит 1 раз в сутки</p>
            </div>
          </div>
        </div>
        <div class="grid align-items-center">
          <div class="col-6 no-padding">
            <p>из {{onParseNumberValue(CrowdCountTotal)}} руб.</p>
          </div>
          <div class="col-6 no-padding text-right">
            <p class="txt-caption">Собрано {{CrowdCountPercent}}%</p>
          </div>
        </div>
        <div class="grid align-items-center pt-4 pb-4">
          <div class="crowdfunding__counter-progress">
            <span [ngStyle]="{'width.%': CrowdCountPercent}"></span>
          </div>
        </div>
        <div class="grid align-items-center">
          <div class="col-auto mr-6">
            <p><strong>{{CrowdCountCount}} раз</strong></p>
            <p class="txt-caption">поддержали</p>
          </div>
          <div class="col-auto mr-6">
            <p><strong>10 апреля 2020</strong></p>
            <p class="txt-caption">запущен</p>
          </div>
        </div>
        <div class="grid align-items-center justify-content-center"
          ngClass="{{(deviceValue | async) === DTypes.Tablet ? 'pt-12' : 'pt-7'}}">
          <div class="no-padding col-5 col-md-8 col-sm-12">
            <button class="ui-buttons ui-buttons__blue-large" (click)="onCrowdRouterLink()">
              Поддержать проект
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="crowdfunding__wrapper" *ngIf="CrowdfundingView === CVTypes.About"
  ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'pt-6' : 'pt-4'}}">

  <div class="crowdfunding__content">
    <div class="crowdfunding__heading">
      <div class="grid align-items-baseline">
        <span class="mr-icon mr-icon-info"></span>
        <h5 class="ml-2">Несколько слов о нас</h5>
      </div>
    </div>
    <div class="crowdfunding__text">
      <div class="grid align-items-start"
        ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? '' : 'flex-column'}}">

        <div class="no-padding"
          ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'col-5' : 'col-12'}}">

          <p class="pt-4">
            Мы музыканты и «горим» музыкой всю свою жизнь.
            Несколько лет назад, мы с моим коллегой случайно познакомились и поняли, что имеем много общего.
          </p>
          <p class="pt-4">
            Так завязалась наша дружба, которая переросла за несколько лет в плодотворное партнерство – возможно вы что-то
            слышали или видели в интернете о нас и наших трудах, а именно о проектах
            <strong>Музыканты Москвы, Музыканты России, и Мобильном приложении "Музыканты России"</strong>,
            но о них подробнее расскажем чуть позже.
          </p>
        </div>

        <div class="no-padding"
          ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'col-7' : 'col-12'}}">

          <div class="grid justify-content-end pt-4">
            <div class="no-padding"
              ngClass="{{(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet ? 'col-10' : 'col-12'}}">

              <iframe src="https://www.youtube.com/embed/kS2YbNkbjpA"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen="allowfullscreen">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
